<template>
  <div id="app"> 
    <HeaderComp v-if="!authpage"/>

    <main v-if="nav" class="container-fluid">
      <Nav/>  
    </main>  

    <vue-page-transition :name="!authpage ?'fade':''">
      <router-view/>
    </vue-page-transition>

    <!-- <BannerCookies v-if="!authpage && pendingCookies == null" /> -->
  </div>
</template>

<script> 
 import Nav from "./components/company/nav";
// import BannerCookies from "./components/BannerCookies.vue";
export default {
  name: 'App',
  components: { 
    Nav, 
    // BannerCookies
  },
  data() {
    return {
      authpage: true, 
      nav: false,
      // pendingCookies: localStorage.getItem('consentCookies')
    };
  },
  watch: {
    '$route' () {
      const publicPages = ['/login', 
      '/register', '/register_ame', '/register_avenue', '/register_natura', '/company', 
      '/company/member', '/forgot-password', 
      '/reset-password', '/validation',  
      '/program-list', '/auth/sso', '/auth/sso/', '/sso/logout'];
      this.authpage = publicPages.includes(this.$route.path) || this.$route.meta.slug; 
      this.nav = this.$route.meta.nav;
    }
  },  
}
</script>

<style>
#app {
  font-family: 'Poligon', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.circleImg { 
  border-radius: 50%;
  width: 42px;
  height: 42px;
  overflow: hidden;
  position: relative;
}

.circleImg img {
  position: absolute;
  bottom: 0; 
  height: 100%;
}

element.style {
  display: flex;
}
 
.swal2-title { 
  font-weight: 500 !important; 
}
.CodeMirror .cm-spell-error:not(.cm-url):not(.cm-comment):not(.cm-tag):not(.cm-word) {
  background: transparent !important;
}
/* // override default multiselect styles */
.multiselect__option--highlight {
  background: rgb(115,12,168) !important;
}

.multiselect__option--highlight:after {
  background: rgb(115,12,168) !important;
}

.dropdown-menu:focus {
  outline: none !important;
} 

.modal-backdrop {
  background-color: rgba(2,2,2,.258) !important;
}

.b-sidebar { 
  top: 65px !important;  
  height: unset !important;    
}
#modal-create-credential .close{
  display: none;
}

 #modal-view-credential .close{
  display: none;
}
button.swal2-styled.swal2-cancel {
  padding: 9px 14px 8px;
  font-size: 0.93rem;
  color: #E10E71 !important;
  background: none !important;
  border: 1px solid #E10E71 !important;
  transition: 0.5s;
  text-decoration: none;
  height: 41px;
}
button.swal2-styled.swal2-confirm {
  background: #730BA9 !important;
  height: 41px;
}
#modal-edit-scope > .modal-body{
padding: 0px;
}
.introjs-prevbutton{
    background: #fff !important;
    border: 1px solid #E10E71 !important;
    color: #E10E71 !important;
    font-weight: normal !important;
    text-shadow: none !important;
    font-family: Poligon !important;
    font-weight: 400 !important;
    cursor: pointer;
  }
.introjs-nextbutton {
  background: #730BA9 !important;
  border: none !important;
  color: white !important;
  font-weight: normal !important;
  text-shadow: none !important;
  font-family: Poligon !important;
  font-weight: 400 !important;
  cursor: pointer;
  }

div.swal2-content{
    padding: 0px;
  }


/* CSS componente de gerenciamento de versões */ 
.code-diff-view {
  margin-bottom: 0px;
}
.blob-code-deletion,
.blob-code-addition,
.blob-code-context {
  width: 100%;
}

.empty-cell {
  display: none;
}

.diff-table {
  display: grid;
} 

#modal-version-management  .modal-header{
  border-bottom: none;
}
#modal-version-management  .modal-body{
  padding: 0px !important;
}

#modal-erros-idp .modal-body{
  overflow: auto;
  height: 600px;
}
</style>
